import React from "react";
import PropTypes from "prop-types";
import moment from "moment";

const TimeFromNow = ({ date, suffix = true }) => (
	<span title={moment(date).format("DD MMM YYYY hh:mm:ss A")}>
		{moment(date).fromNow(!suffix)} ago
	</span>
);

TimeFromNow.propTypes = {
	date: PropTypes.string.isRequired,
	suffix: PropTypes.bool
};

export default TimeFromNow;
